import { Banners } from '@/api/models/banners'

const state = {
    list: [],
    model: null,
}

const mutations = {
    SET_LIST(state, val) {
        state.list = val
    },

    SET_MODEL(state, val) {
        state.model = val
    },
}

const actions = {
    fetch({ commit }, id) {
        const banners = new Banners()
        return banners.fetch(id).then((res) => {
            if (id) commit('SET_MODEL', res?.data || res)
            else commit('SET_LIST', res?.data || res)
            return res
        })
    },
}

const getters = {
    list: (state) => state.list,
    model: (state) => state.model,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
